<template>
    <span>
        <div class="flex flex-col w-full h-52 items-center justify-center splash-screen-loading-box" 
            v-if="!('activity' in storeEvents.eventSelected)">
            <n-spin :size="80" />
        </div>
        <div v-else-if="storeEvents.eventSelected.activity != undefined">
            <UTQForm v-if="storeEvents.eventSelected.activity.code == 'UTQ'"/>
            <TapasForm v-else-if="storeEvents.eventSelected.activity.code == 'Tapas'"/>
            <IpadHuntForm v-else-if="storeEvents.eventSelected.activity.code == 'IH'"/>
            <ActionForm v-else-if="storeEvents.eventSelected.activity.code == 'AC' || storeEvents.eventSelected.activity.code == 'ACS'"/>
            <CluedoAIForm v-else-if="storeEvents.eventSelected.activity.code == 'CAI'"/>
            <MusicalBingoForm v-else-if="storeEvents.eventSelected.activity.code == 'MB'"/>
            <CollaboForm v-else-if="storeEvents.eventSelected.activity.code == 'COLLABO'"/>
            <CommonSenseForm v-else-if="storeEvents.eventSelected.activity.code == 'CS'"/>

        </div>
    </span>
</template>


<script lang="ts" setup>
import { useEventsStore } from "@/stores/apps/events"
import UTQForm from "@/views/ActivityCRUD/UTQ.vue"
import TapasForm from "@/views/ActivityCRUD/Tapas.vue"
import IpadHuntForm from "@/views/ActivityCRUD/IpadHunt.vue"
import ActionForm from "@/views/ActivityCRUD/Action.vue"
import CluedoAIForm from "@/views/ActivityCRUD/CluedoAI.vue"
import MusicalBingoForm from "@/views/ActivityCRUD/MusicalBingo.vue"
import CollaboForm from "@/views/ActivityCRUD/Collabo.vue"
import CommonSenseForm from "@/views/ActivityCRUD/CommonSense.vue"
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { NSpin } from "naive-ui"


const storeEvents = useEventsStore()

const route = useRoute()

onMounted( async () => {
    if( 'api_key' in route.params && route.params.api_key != undefined)
    {
        await storeEvents.getEvent(String(route.params.api_key))
    }
});

</script>

<style lang="scss" scoped>
.components-list {
	grid-template-columns: none;
}
.card-css {
    background-color: var(--bg-color);
}
</style>
